import {
  UpdateHakimoMonitoringPayload,
  UpdateHakimoMonitoringResponse,
} from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useUpdateHakimoMonitoring(
  tenantId: string,
  onSuccess?: (data: UpdateHakimoMonitoringResponse) => void,
  onError?: (err: Error) => void
) {
  const url = `/v2/orm/admin/tenants/${tenantId}/enable-hakimo-monitoring`;
  const request = new Request(url, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return useAuthenticatedMutation<
    UpdateHakimoMonitoringResponse,
    UpdateHakimoMonitoringPayload
  >(request, {
    onSuccessInvalidationKeys: [
      ['admin-tenant-details', tenantId],
      ['admin-tenants'],
    ],
    onSuccess,
    onError,
  });
}

export default useUpdateHakimoMonitoring;
